import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';
import { mediaquery } from 'shared/styles/styleFunctions';

export default css({
  '.profile-info-prompt': {
    '&__message': {
      padding: `${theme.space[5]} ${theme.space[5]} ${theme.space[6]} ${theme.space[5]} `,
    },
    '&__footer': {
      borderTop: `1px solid ${COLORS.NEUTRAL200}`,
      padding: theme.space[5],
      justifyContent: 'flex-end',
    },
    '&__message ul': {
      margin: `${theme.space[4]} 0`,
    },
  },
});
